import { type ReactNode } from 'react'
import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface AuthorizationSignedProgressionActionsProps {
  isAnyExtensionFlowAvailable: boolean
  onUploadFinalDocuments: () => unknown
  extensionActions?: ReactNode
}

export function AuthorizationSignedProgressionActions({
  isAnyExtensionFlowAvailable,
  onUploadFinalDocuments,
  extensionActions,
}: AuthorizationSignedProgressionActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding={isAnyExtensionFlowAvailable}>
        <Button
          label="Upload Final Documents"
          variant="primary"
          size="wide-slim"
          onPress={onUploadFinalDocuments}
          testId="job-progression-file-return-button"
        />
      </CardContent>

      {extensionActions}
    </>
  )
}
